import { useUserEventLogger } from '@repo/tracking-service';
import { TextButton } from '@repo/ui';
import cn from 'clsx';

import s from './Reviews.module.scss';

const CustomerReviews = ({ openVideoPopup }: { openVideoPopup: (videoLink: string) => void }) => {
  const { sendClickEvent } = useUserEventLogger();

  const playVideo = (videoLink: string, index: number) => {
    sendClickEvent('landing_review_reviews-more', { item: CUSTOMER_ITEM[index]?.eventItem ?? '' });

    openVideoPopup(videoLink);
  };

  return (
    <div className={'flex justify-center'}>
      <div className={'app-side-padding flex w-full max-w-screen-lg flex-col items-center pb-[4em] pt-[8em]'}>
        <div className="heading-8">비즈넵 환급을 이용한 사장님은</div>
        <div className={'heading-3 mb-[1.25em] mt-[0.15em]'}>이렇게 환급받았어요.</div>
        {CUSTOMER_ITEM.map((item, index) => (
          <div key={index} className={cn(s[item.color], s.customer_review_video_card)} onClick={() => playVideo(item.video_link, index)}>
            <figure className={s.video_card_thumbnail}>
              <img src={item.thumbnail} className={s.image} alt={'thumbnail'} />
              <button className={s.play_button}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width="48" height="48" focusable="false">
                  <g>
                    <path d="M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36.4,110.7-48,32A8.7,8.7,0,0,1,112,168a8.5,8.5,0,0,1-3.8-.9A8,8,0,0,1,104,160V96a8,8,0,0,1,4.2-7.1,8.3,8.3,0,0,1,8.2.4l48,32a8,8,0,0,1,0,13.4Z" />
                  </g>
                </svg>
              </button>
            </figure>
            <div className={s.text_wrapper}>
              <div className={'font-bold'}>{item.message}</div>
              <div className={'paragraph-5 pt-[0.5em]'}>“{item.description}”</div>
              <div className={'paragraph-6 pt-[1em] font-medium'}>{item.name} 대표님</div>
              <div className={'paragraph-7 pb-[1em] pt-[0.25em] font-medium opacity-70'}>
                <span className={`mr-[0.25em] pr-[0.25em] after:!bg-[rgba(255,255,255,0.7)] ${s.reviews_divider} `}>{item.business_name}</span>
                <span>{item.business_type}</span>
              </div>
              <div className={s.play_button_wrapper}>
                <TextButton size={'small'} className={`${s.play_button} text-white`}>
                  <span>영상 보기</span>
                </TextButton>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerReviews;

const CUSTOMER_ITEM = [
  {
    message: '세무서보다 꼼꼼하다면, 안 쓸 이유 없죠.',
    description:
      '신청 후 뭔가 잘못됐다는 세무서의 연락을 받고 깜짝 놀랐죠. 그런데 알고 보니 세무서가 비즈넵의 보고를 놓쳤던 거더라고요. 이런 꼼꼼함이라면 비즈넵 환급 안 쓸 이유가 없잖아요?',
    business_name: '미우디자인',
    business_type: '간판광고 디자인',
    name: '강대현',
    thumbnail: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/reviews/review1.png`,
    video_link: 'https://www.youtube.com/embed/fIozODvOPSw',
    color: 'violet-500',
    eventItem: 'miwoo'
  },
  {
    message: '네이버가 아무에게나 투자했겠어요?',
    description:
      '정신없는 와중에 매일 같이 걸려오는 영업전화 받다보면 너무 피로해지더라고요. 그렇다고 해서 아무 서비스나 쓸 수도 없는 노릇이지만, 네이버 투자사라면 믿을 수 있겠다는 생각이 들었죠.',
    business_name: '능이야',
    business_type: '음식점',
    name: '김명원',
    thumbnail: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/reviews/review3.png`,
    video_link: 'https://www.youtube.com/embed/D2dJ_zTechE',
    color: 'cyan-700',
    eventItem: 'neungya'
  },
  {
    message: '이 자리를 빌어 추천합니다, 꼭 써보세요',
    description:
      '기대하지도 못했던 환급금이 나왔을 때의 그 짜릿함은 직접 경험해보지 않고서야 모릅니다. 일단 한 번 써보세요. 이미 주변에 추천을 많이 해드리고 있네요.',
    business_name: '담금주한잔',
    business_type: '제조업',
    name: '박종호',
    thumbnail: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/reviews/review4.png`,
    video_link: 'https://www.youtube.com/embed/qXOMo9JDGN4',
    color: 'cornflower-500',
    eventItem: 'damgum'
  },
  {
    message: '소상공인 세금 관리방법에는 절세만 있는 게 아니더라고요!',
    description:
      '비즈넵 환급은, 입점해 있는 네이버 스마트플레이스에서 처음 접했어요. 호기심이 생겨 여러 방면으로 서비스를 조사해 봤고요. 소상공인의 입장에서 ‘세금 환급‘이라는 영역은 참 신선했어요.',
    business_name: '위드위치',
    business_type: '브런치전문업체',
    name: '이상훈',
    thumbnail: `${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/refund/images/home/reviews/review5.png`,
    video_link: 'https://www.youtube.com/embed/M-dQXlkcpYg',
    color: 'violet-500',
    eventItem: 'withwitch'
  }
];
